<script setup lang="ts">
import { tpgIconPublics } from '@tpg/grammar-web-icons';

import { GrammarIcon } from '@nora-monorepo/grammar-ui';

import { getAvatarColors } from '#ui-shared/components/avatar-image/get-avatar-color';

interface AvatarImageProps {
  text?: string;
  icon?: string;
  isSmall?: boolean;
  id: string;
  operationId?: string | null;
}

const props = defineProps<AvatarImageProps>();

const avatarColors = props.id ? getAvatarColors(props.id) : null;

const style = {
  background: props.icon ? avatarColors?.foreground : avatarColors?.background,
  color: props.icon ? avatarColors?.background : avatarColors?.foreground,
};
</script>

<template>
  <div
    class="inline-flex items-center justify-center overflow-hidden rounded-full shrink-0"
    :class="[isSmall ? 'w-8 h-8' : 'w-10 h-10']"
    :title="text"
    :style="style"
  >
    <div v-if="operationId">
      <GrammarIcon :icon-template="tpgIconPublics" size="xlarge" style="--iconVectorFill: var(--colorNeutralForegroundXxLowEmphasis)" />
    </div>
    <span
      v-else-if="icon"
      class="mi"
      :class="icon"
    />
    <span
      v-else-if="text"
      class="font-normal"
      :class="[isSmall ? 'text-md' : 'text-lg']"
    >
      {{ text }}
    </span>
  </div>
</template>
